export const environment = {
  production: false,
  apiUrl: 'https://espressoday.softsale.kz',
};
